import { accountIdFormat } from "@redotech/redo-model/ids";
import { PriceBookRowSchema } from "@redotech/redo-model/price-book/price-book";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const createPriceBook = unaryRpc({
  name: "createPriceBook" as const,
  input: z.object({
    accountId: accountIdFormat.schema,
    name: z.string(),
    description: z.string().optional(),
  }),
  output: z.object({ priceBook: PriceBookRowSchema }),
});
